var map = {
	".": 220,
	"./": 220,
	"./Addresses": 11,
	"./Addresses.js": 11,
	"./Api": 21,
	"./Api/": 21,
	"./Api/common": 103,
	"./Api/common.js": 103,
	"./Api/index": 21,
	"./Api/index.js": 21,
	"./Api/prices": 274,
	"./Api/prices.js": 274,
	"./Api/referrals": 250,
	"./Api/referrals.js": 250,
	"./App": 298,
	"./App.css": 522,
	"./App.js": 298,
	"./AppOrder.css": 523,
	"./Constants": 59,
	"./Constants.js": 59,
	"./Font.css": 524,
	"./Footer": 69,
	"./Footer.css": 525,
	"./Footer.js": 69,
	"./Helpers": 2,
	"./Helpers.js": 2,
	"./Input.css": 526,
	"./Shared.css": 527,
	"./__tests__/Helpers": 528,
	"./__tests__/Helpers.js": 528,
	"./_development.Addresses": 529,
	"./_development.Addresses.js": 529,
	"./abis/ANZOR": 530,
	"./abis/ANZOR.json": 530,
	"./abis/EQUITY": 531,
	"./abis/EQUITY.json": 531,
	"./abis/ERC721": 306,
	"./abis/ERC721.json": 306,
	"./abis/EqualOrderNft": 532,
	"./abis/EqualOrderNft.json": 532,
	"./abis/EqualOrderSale": 533,
	"./abis/EqualOrderSale.json": 533,
	"./abis/EqualOrderStaking": 534,
	"./abis/EqualOrderStaking.json": 534,
	"./abis/EqualizerV2Voter": 535,
	"./abis/EqualizerV2Voter.json": 535,
	"./abis/EquityFarm": 104,
	"./abis/EquityFarm.json": 104,
	"./abis/EquityManager": 111,
	"./abis/EquityManager.json": 111,
	"./abis/EquityToken": 307,
	"./abis/EquityToken.json": 307,
	"./abis/InfoSupply": 300,
	"./abis/InfoSupply.json": 300,
	"./abis/MintableBaseToken": 536,
	"./abis/MintableBaseToken.json": 536,
	"./abis/OrderBook": 97,
	"./abis/OrderBook.json": 97,
	"./abis/OrderBookReader": 308,
	"./abis/OrderBookReader.json": 308,
	"./abis/PositionManager": 299,
	"./abis/PositionManager.json": 299,
	"./abis/PositionRouter": 102,
	"./abis/PositionRouter.json": 102,
	"./abis/Reader": 64,
	"./abis/Reader.json": 64,
	"./abis/ReferralStorage": 163,
	"./abis/ReferralStorage.json": 163,
	"./abis/RewardReader": 112,
	"./abis/RewardReader.json": 112,
	"./abis/RewardRouter": 89,
	"./abis/RewardRouter.json": 89,
	"./abis/RewardTracker": 177,
	"./abis/RewardTracker.json": 177,
	"./abis/Router": 158,
	"./abis/Router.json": 158,
	"./abis/Token": 45,
	"./abis/Token.json": 45,
	"./abis/UniPool": 196,
	"./abis/UniPool.json": 196,
	"./abis/UniswapV2": 537,
	"./abis/UniswapV2.json": 537,
	"./abis/Vault": 81,
	"./abis/Vault.json": 81,
	"./abis/VaultReader": 301,
	"./abis/VaultReader.json": 301,
	"./abis/VeEqual": 390,
	"./abis/VeEqual.json": 390,
	"./abis/Vester": 131,
	"./abis/Vester.json": 131,
	"./abis/WETH": 251,
	"./abis/WETH.json": 251,
	"./abis/YieldFarm": 538,
	"./abis/YieldFarm.json": 538,
	"./abis/YieldToken": 539,
	"./abis/YieldToken.json": 539,
	"./components/APRLabel/APRLabel": 397,
	"./components/APRLabel/APRLabel.js": 397,
	"./components/AddressDropdown/AddressDropdown": 309,
	"./components/AddressDropdown/AddressDropdown.css": 540,
	"./components/AddressDropdown/AddressDropdown.js": 309,
	"./components/BlueWaves/BlueWaves": 314,
	"./components/BlueWaves/BlueWaves.css": 549,
	"./components/BlueWaves/BlueWaves.js": 314,
	"./components/BuyInputSection/BuyInputSection": 179,
	"./components/BuyInputSection/BuyInputSection.css": 550,
	"./components/BuyInputSection/BuyInputSection.js": 179,
	"./components/Checkbox/Checkbox": 58,
	"./components/Checkbox/Checkbox.css": 551,
	"./components/Checkbox/Checkbox.js": 58,
	"./components/Common/Button": 315,
	"./components/Common/Button.css": 552,
	"./components/Common/Button.js": 315,
	"./components/Common/Card": 553,
	"./components/Common/Card.css": 555,
	"./components/Common/Card.js": 553,
	"./components/Common/Loader": 556,
	"./components/Common/Loader.css": 557,
	"./components/Common/Loader.js": 556,
	"./components/Common/SEO": 116,
	"./components/Common/SEO.js": 116,
	"./components/Equity/EquitySwap": 316,
	"./components/Equity/EquitySwap.css": 561,
	"./components/Equity/EquitySwap.js": 316,
	"./components/EventToast/AnnouncementIcon": 321,
	"./components/EventToast/AnnouncementIcon.js": 321,
	"./components/EventToast/EventToast": 322,
	"./components/EventToast/EventToast.css": 563,
	"./components/EventToast/EventToast.js": 322,
	"./components/EventToast/EventToastContainer": 323,
	"./components/EventToast/EventToastContainer.js": 323,
	"./components/EventToast/useEventToast": 324,
	"./components/EventToast/useEventToast.js": 324,
	"./components/Exchange/ChartTokenSelector": 326,
	"./components/Exchange/ChartTokenSelector.css": 567,
	"./components/Exchange/ChartTokenSelector.js": 326,
	"./components/Exchange/ConfirmationBox": 327,
	"./components/Exchange/ConfirmationBox.js": 327,
	"./components/Exchange/ExchangeInfoRow": 60,
	"./components/Exchange/ExchangeInfoRow.js": 60,
	"./components/Exchange/ExchangeTVChart": 252,
	"./components/Exchange/ExchangeTVChart.js": 252,
	"./components/Exchange/ExchangeWalletTokens": 328,
	"./components/Exchange/ExchangeWalletTokens.css": 568,
	"./components/Exchange/ExchangeWalletTokens.js": 328,
	"./components/Exchange/OrderEditor": 329,
	"./components/Exchange/OrderEditor.js": 329,
	"./components/Exchange/OrdersList": 198,
	"./components/Exchange/OrdersList.css": 569,
	"./components/Exchange/OrdersList.js": 198,
	"./components/Exchange/OrdersToa": 199,
	"./components/Exchange/OrdersToa.css": 570,
	"./components/Exchange/OrdersToa.js": 199,
	"./components/Exchange/PositionEditor": 330,
	"./components/Exchange/PositionEditor.js": 330,
	"./components/Exchange/PositionSeller": 331,
	"./components/Exchange/PositionSeller.js": 331,
	"./components/Exchange/PositionsList": 200,
	"./components/Exchange/PositionsList.js": 200,
	"./components/Exchange/SwapBox": 332,
	"./components/Exchange/SwapBox.js": 332,
	"./components/Exchange/TokenSelector": 146,
	"./components/Exchange/TokenSelector.css": 560,
	"./components/Exchange/TokenSelector.js": 146,
	"./components/Exchange/TradeHistory": 201,
	"./components/Exchange/TradeHistory.css": 571,
	"./components/Exchange/TradeHistory.js": 201,
	"./components/InputSection/InputSection": 572,
	"./components/InputSection/InputSection.css": 573,
	"./components/InputSection/InputSection.js": 572,
	"./components/Modal/Modal": 50,
	"./components/Modal/Modal.css": 559,
	"./components/Modal/Modal.js": 50,
	"./components/NetworkSelector/Indicator.svg": 942,
	"./components/NetworkSelector/NetworkSelector": 253,
	"./components/NetworkSelector/NetworkSelector.css": 574,
	"./components/NetworkSelector/NetworkSelector.js": 253,
	"./components/Overlay/Overlay": 720,
	"./components/Overlay/Overlay.css": 721,
	"./components/Overlay/Overlay.js": 720,
	"./components/Radio/Radio": 722,
	"./components/Radio/Radio.css": 723,
	"./components/Radio/Radio.js": 722,
	"./components/Tab/Tab": 94,
	"./components/Tab/Tab.css": 558,
	"./components/Tab/Tab.js": 94,
	"./components/TokenCard/TokenCard": 202,
	"./components/TokenCard/TokenCard.css": 946,
	"./components/TokenCard/TokenCard.js": 202,
	"./components/Tooltip/Tooltip": 29,
	"./components/Tooltip/Tooltip.css": 554,
	"./components/Tooltip/Tooltip.js": 29,
	"./components/WarningBanner/WarningBanner": 342,
	"./components/WarningBanner/WarningBanner.css": 724,
	"./components/WarningBanner/WarningBanner.js": 342,
	"./config/events": 325,
	"./config/events.js": 325,
	"./contexts/RefreshContext": 155,
	"./contexts/RefreshContext/": 155,
	"./contexts/RefreshContext/RefreshContextProvider": 224,
	"./contexts/RefreshContext/RefreshContextProvider.tsx": 224,
	"./contexts/RefreshContext/index": 155,
	"./contexts/RefreshContext/index.ts": 155,
	"./data/Fees": 343,
	"./data/Fees.js": 343,
	"./data/Tokens": 33,
	"./data/Tokens.js": 33,
	"./fonts/Inter-Bold.ttf": 947,
	"./fonts/Inter.ttf": 948,
	"./fonts/etna.otf": 949,
	"./fonts/relative/relative-bold-pro.eot": 950,
	"./fonts/relative/relative-bold-pro.ttf": 951,
	"./fonts/relative/relative-bold-pro.woff": 952,
	"./fonts/relative/relative-bold-pro.woff2": 953,
	"./fonts/relative/relative-book-pro.eot": 954,
	"./fonts/relative/relative-book-pro.ttf": 955,
	"./fonts/relative/relative-book-pro.woff": 956,
	"./fonts/relative/relative-book-pro.woff2": 957,
	"./fonts/relative/relative-faux-book-pro.eot": 958,
	"./fonts/relative/relative-faux-book-pro.ttf": 959,
	"./fonts/relative/relative-faux-book-pro.woff": 960,
	"./fonts/relative/relative-faux-book-pro.woff2": 961,
	"./fonts/relative/relative-medium-pro.eot": 962,
	"./fonts/relative/relative-medium-pro.ttf": 963,
	"./fonts/relative/relative-medium-pro.woff": 964,
	"./fonts/relative/relative-medium-pro.woff2": 965,
	"./fonts/relative/relative-mono-10-pitch-pro.eot": 966,
	"./fonts/relative/relative-mono-10-pitch-pro.ttf": 967,
	"./fonts/relative/relative-mono-10-pitch-pro.woff": 968,
	"./fonts/relative/relative-mono-10-pitch-pro.woff2": 969,
	"./hooks/useDebounce": 725,
	"./hooks/useDebounce.ts": 725,
	"./hooks/useIsWindowVisible": 726,
	"./hooks/useIsWindowVisible.ts": 726,
	"./hooks/useLockBodyScroll": 317,
	"./hooks/useLockBodyScroll.js": 317,
	"./hooks/useRefresh": 727,
	"./hooks/useRefresh.ts": 727,
	"./hooks/useRouteQuery": 344,
	"./hooks/useRouteQuery.js": 344,
	"./img/ANZOR_logo.svg": 575,
	"./img/Anyswap.png": 403,
	"./img/Anyswap.svg": 576,
	"./img/Artwork.svg": 577,
	"./img/Artwork_gmx.svg": 578,
	"./img/Banxa.png": 404,
	"./img/DROP_DOWN.svg": 318,
	"./img/Equity_iconlogo.svg": 137,
	"./img/Hop.png": 405,
	"./img/Hop.svg": 579,
	"./img/Hop_dark.png": 406,
	"./img/Hop_dark.svg": 580,
	"./img/MVX_logo.svg": 581,
	"./img/Multichain.png": 238,
	"./img/Synapse.png": 407,
	"./img/Synapse.svg": 336,
	"./img/anzor-logo.png": 408,
	"./img/anzor.png": 409,
	"./img/axlUSDC.png": 410,
	"./img/banner-avt.9083d854.png": 411,
	"./img/banner-bg-small.f86fb377.png": 412,
	"./img/banner-bg.5241de9f.png": 413,
	"./img/banner-vector.d1966b5c.png": 414,
	"./img/bg.50b2dacb.png": 415,
	"./img/binance.png": 416,
	"./img/bscscan.png": 417,
	"./img/btn_big_arbitrum.png": 418,
	"./img/btn_big_avalanche.png": 419,
	"./img/btn_big_bsc.png": 420,
	"./img/btn_big_new.svg": 582,
	"./img/btn_big_purchasegmx.png": 421,
	"./img/btn_big_purchasegmx.svg": 583,
	"./img/btn_big_purchasemvx.svg": 584,
	"./img/buy_gmx.svg": 585,
	"./img/buy_gmx_bond.svg": 586,
	"./img/buy_transfer_eth.svg": 587,
	"./img/cbridgev2.svg": 461,
	"./img/chainlink.svg": 395,
	"./img/chart.png": 422,
	"./img/coinbaseWallet.png": 239,
	"./img/coingecko.png": 423,
	"./img/cross.svg": 588,
	"./img/dollar.png": 424,
	"./img/dropdown-ic.b57edcbf.svg": 589,
	"./img/earnlogo.svg": 279,
	"./img/elp-logo-black-min.png": 275,
	"./img/equal-logo.svg": 590,
	"./img/equalizer-logo-big.png": 425,
	"./img/equalswap-logo.png": 240,
	"./img/equity-logo-text.png": 241,
	"./img/equity-logo.png": 426,
	"./img/equity.png": 427,
	"./img/equity_icon.svg": 591,
	"./img/footerpolygon.svg": 592,
	"./img/footerpolygonnew.svg": 593,
	"./img/ftm.5c12026b.svg": 594,
	"./img/glp_icon.svg": 595,
	"./img/gmx-logo-final-white-small.png": 428,
	"./img/gmx-logo-final-white.png": 429,
	"./img/gmx-logo-final.png": 430,
	"./img/gmx-logo-glow.png": 431,
	"./img/gmx_logo.svg": 596,
	"./img/graphite-01.png": 432,
	"./img/home-banner-img.png": 433,
	"./img/home-bg-old.png": 434,
	"./img/home-bg.jpg": 597,
	"./img/home-bg.png": 435,
	"./img/ic-communityproject.svg": 598,
	"./img/ic-info.20267414.svg": 599,
	"./img/ic-mint.dbcd686f.svg": 600,
	"./img/ic_aave_24.svg": 601,
	"./img/ic_aave_40.svg": 602,
	"./img/ic_anzor_40.png": 436,
	"./img/ic_anzor_40.svg": 603,
	"./img/ic_arbitrum_16.svg": 604,
	"./img/ic_arbitrum_24.svg": 605,
	"./img/ic_arbitrum_96.svg": 606,
	"./img/ic_arbitrum_hover_16.svg": 607,
	"./img/ic_avalanche_16.svg": 608,
	"./img/ic_avalanche_24.svg": 609,
	"./img/ic_avalanche_96.svg": 610,
	"./img/ic_avax_24.svg": 611,
	"./img/ic_avax_30.svg": 612,
	"./img/ic_avax_40.svg": 613,
	"./img/ic_axlusdc.png": 437,
	"./img/ic_axlusdc_24.svg": 614,
	"./img/ic_axlusdc_30.svg": 615,
	"./img/ic_axlusdc_40.svg": 616,
	"./img/ic_axlusdc_96.svg": 617,
	"./img/ic_banxa.svg": 618,
	"./img/ic_binance_logo.svg": 619,
	"./img/ic_bsc.svg": 620,
	"./img/ic_bsc_96.svg": 621,
	"./img/ic_btc_24.svg": 622,
	"./img/ic_btc_40.svg": 623,
	"./img/ic_busd_24.svg": 624,
	"./img/ic_buy_equity.svg": 337,
	"./img/ic_buy_glp.svg": 625,
	"./img/ic_buy_mvlp.svg": 626,
	"./img/ic_cash.png": 438,
	"./img/ic_cash.svg": 627,
	"./img/ic_coingecko_16.svg": 628,
	"./img/ic_coingecko_hover_16.svg": 320,
	"./img/ic_convert_down.svg": 319,
	"./img/ic_copy_16.svg": 311,
	"./img/ic_cost.svg": 629,
	"./img/ic_costnew.svg": 630,
	"./img/ic_dai_24.svg": 631,
	"./img/ic_dai_40.svg": 632,
	"./img/ic_discord.svg": 304,
	"./img/ic_equity_24.svg": 633,
	"./img/ic_equity_40.png": 439,
	"./img/ic_equity_40.svg": 634,
	"./img/ic_eth_24.svg": 635,
	"./img/ic_eth_40.svg": 460,
	"./img/ic_fantom_16.svg": 636,
	"./img/ic_fantom_24.svg": 637,
	"./img/ic_fantom_96.svg": 638,
	"./img/ic_frax_24.svg": 639,
	"./img/ic_frax_40.svg": 640,
	"./img/ic_ftm_24.svg": 641,
	"./img/ic_ftm_30.svg": 642,
	"./img/ic_ftm_40.svg": 643,
	"./img/ic_gitbook.svg": 305,
	"./img/ic_github.svg": 393,
	"./img/ic_glp_24.svg": 644,
	"./img/ic_glp_40.svg": 645,
	"./img/ic_glp_custom.svg": 646,
	"./img/ic_gmx.svg": 647,
	"./img/ic_gmx_24.svg": 648,
	"./img/ic_gmx_30.svg": 649,
	"./img/ic_gmx_40.svg": 650,
	"./img/ic_gmx_64.svg": 651,
	"./img/ic_gmx_arbitrum.svg": 652,
	"./img/ic_gmx_avax.svg": 653,
	"./img/ic_gmx_big.svg": 654,
	"./img/ic_gmx_custom.svg": 655,
	"./img/ic_gmx_footer.svg": 656,
	"./img/ic_hop.svg": 657,
	"./img/ic_info.svg": 658,
	"./img/ic_link_24.svg": 659,
	"./img/ic_link_40.svg": 660,
	"./img/ic_liq.svg": 661,
	"./img/ic_liquidity.svg": 662,
	"./img/ic_matic_16.svg": 663,
	"./img/ic_matic_16new.svg": 664,
	"./img/ic_matic_24.svg": 665,
	"./img/ic_matic_40.svg": 666,
	"./img/ic_medium.svg": 394,
	"./img/ic_metamask_16.svg": 667,
	"./img/ic_metamask_hover_16.svg": 197,
	"./img/ic_mim_24.svg": 668,
	"./img/ic_mim_40.svg": 669,
	"./img/ic_multiswap.svg": 670,
	"./img/ic_mvlp_24.svg": 671,
	"./img/ic_mvlp_40.png": 440,
	"./img/ic_mvlp_40.svg": 672,
	"./img/ic_mvx_40.png": 441,
	"./img/ic_mvx_40.svg": 673,
	"./img/ic_new_link_16.svg": 310,
	"./img/ic_olympus.svg": 674,
	"./img/ic_olympus_arbitrum.svg": 675,
	"./img/ic_polygon.svg": 676,
	"./img/ic_polygon_16.svg": 677,
	"./img/ic_polygon_24.svg": 678,
	"./img/ic_selector_dropdowns.svg": 206,
	"./img/ic_settings_16.svg": 312,
	"./img/ic_sign in_16.svg": 679,
	"./img/ic_sign_out_16.svg": 313,
	"./img/ic_simplenew.svg": 680,
	"./img/ic_simpleswaps.svg": 681,
	"./img/ic_stats.svg": 682,
	"./img/ic_stats_big.svg": 338,
	"./img/ic_synapse.svg": 683,
	"./img/ic_telegram.svg": 392,
	"./img/ic_tether_24.svg": 684,
	"./img/ic_tokens.svg": 339,
	"./img/ic_totaluser.svg": 685,
	"./img/ic_trading.svg": 686,
	"./img/ic_transfer_avax.svg": 687,
	"./img/ic_twitter.svg": 303,
	"./img/ic_uni_24.svg": 688,
	"./img/ic_uni_40.svg": 689,
	"./img/ic_usdc.e_24.svg": 690,
	"./img/ic_usdc.e_40.svg": 691,
	"./img/ic_usdc_24.svg": 692,
	"./img/ic_usdc_40.svg": 693,
	"./img/ic_usdt_24.svg": 694,
	"./img/ic_usdt_40.svg": 695,
	"./img/ic_wallet_24.svg": 340,
	"./img/ic_wavax_24.svg": 696,
	"./img/ic_wavax_40.svg": 697,
	"./img/ic_weth_24.svg": 698,
	"./img/ic_weth_40.svg": 699,
	"./img/ic_wftm_24.svg": 700,
	"./img/ic_wftm_40.svg": 701,
	"./img/ic_wmatic_24.svg": 702,
	"./img/ic_wmatic_40.svg": 703,
	"./img/lg_arbitrum.svg": 704,
	"./img/lg_fantom.svg": 462,
	"./img/lg_near.svg": 705,
	"./img/lg_polygon.svg": 706,
	"./img/link-green.8997d55b.svg": 707,
	"./img/link-white.5228d68c.svg": 708,
	"./img/linktree_white.svg": 396,
	"./img/liquidation.png": 242,
	"./img/logo-equal.png": 157,
	"./img/logo-equity.png": 88,
	"./img/logo-fantom.png": 71,
	"./img/logo_ANZOR.svg": 709,
	"./img/logo_ANZOR_small.svg": 710,
	"./img/logo_MVX.svg": 711,
	"./img/long.svg": 333,
	"./img/lzUSDC.png": 442,
	"./img/lzusdc.webp": 712,
	"./img/man.png": 443,
	"./img/manage-swaps.png": 444,
	"./img/metamask-text.svg": 713,
	"./img/metamask.png": 445,
	"./img/money.png": 446,
	"./img/mum1.826066ac.png": 447,
	"./img/mum2.19e61eee.png": 448,
	"./img/mvlp.png": 449,
	"./img/mvx.png": 450,
	"./img/mvxheader.svg": 714,
	"./img/nfts/equal-footer-banner-left.png": 451,
	"./img/nfts/equal-footer-banner-right.png": 452,
	"./img/nfts/equal-nft-banner-avatar.png": 453,
	"./img/open-interest.png": 454,
	"./img/openinterest.png": 243,
	"./img/openinterest.svg": 715,
	"./img/page-not-found.svg": 716,
	"./img/placeholder.svg": 717,
	"./img/save-costs.png": 244,
	"./img/short.svg": 334,
	"./img/simple-swaps.png": 245,
	"./img/solid_background_3.png": 455,
	"./img/swap.svg": 335,
	"./img/total-users.png": 246,
	"./img/total-volume.png": 247,
	"./img/totalusers.svg": 718,
	"./img/totalvolume.png": 456,
	"./img/trading.png": 457,
	"./img/wallet-connect-text.svg": 719,
	"./img/walletconnect-circle-blue.svg": 341,
	"./img/wave-01.png": 458,
	"./img/wave-02.png": 459,
	"./img/xpollinate.svg": 463,
	"./index": 220,
	"./index.css": 517,
	"./index.js": 220,
	"./logo.svg": 970,
	"./react-app-env.d": 728,
	"./react-app-env.d.ts": 728,
	"./reportWebVitals": 345,
	"./reportWebVitals.js": 345,
	"./views/Actions/Actions": 255,
	"./views/Actions/Actions.css": 729,
	"./views/Actions/Actions.js": 255,
	"./views/BeginAccountTransfer/BeginAccountTransfer": 346,
	"./views/BeginAccountTransfer/BeginAccountTransfer.css": 731,
	"./views/BeginAccountTransfer/BeginAccountTransfer.js": 346,
	"./views/Buy/Buy": 347,
	"./views/Buy/Buy.css": 732,
	"./views/Buy/Buy.js": 347,
	"./views/BuyEQUAL/BuyEQUAL": 348,
	"./views/BuyEQUAL/BuyEQUAL.css": 733,
	"./views/BuyEQUAL/BuyEQUAL.js": 348,
	"./views/BuyEquity/BuyEquity": 349,
	"./views/BuyEquity/BuyEquity.css": 734,
	"./views/BuyEquity/BuyEquity.js": 349,
	"./views/ClaimEsEqual/ClaimEsEqual": 350,
	"./views/ClaimEsEqual/ClaimEsEqual.css": 971,
	"./views/ClaimEsEqual/ClaimEsEqual.js": 350,
	"./views/CompleteAccountTransfer/CompleteAccountTransfer": 351,
	"./views/CompleteAccountTransfer/CompleteAccountTransfer.css": 735,
	"./views/CompleteAccountTransfer/CompleteAccountTransfer.js": 351,
	"./views/Dashboard/AssetDropdown": 161,
	"./views/Dashboard/AssetDropdown.css": 562,
	"./views/Dashboard/AssetDropdown.js": 161,
	"./views/Dashboard/Dashboard": 352,
	"./views/Dashboard/Dashboard.css": 1204,
	"./views/Dashboard/Dashboard.js": 352,
	"./views/Dashboard/DashboardV2": 353,
	"./views/Dashboard/DashboardV2.css": 736,
	"./views/Dashboard/DashboardV2.js": 353,
	"./views/Debug/Debug": 354,
	"./views/Debug/Debug.js": 354,
	"./views/Ecosystem/Ecosystem": 355,
	"./views/Ecosystem/Ecosystem.css": 843,
	"./views/Ecosystem/Ecosystem.js": 355,
	"./views/Exchange/Exchange": 178,
	"./views/Exchange/Exchange.css": 730,
	"./views/Exchange/Exchange.js": 178,
	"./views/FarmEquity/FarmEquity": 356,
	"./views/FarmEquity/FarmEquity.css": 844,
	"./views/FarmEquity/FarmEquity.js": 356,
	"./views/Home/Home": 210,
	"./views/Home/Home.css": 845,
	"./views/Home/Home.js": 210,
	"./views/NftWallet/NftWallet": 357,
	"./views/NftWallet/NftWallet.css": 846,
	"./views/NftWallet/NftWallet.js": 357,
	"./views/OrdersOverview/OrdersOverview": 358,
	"./views/OrdersOverview/OrdersOverview.css": 847,
	"./views/OrdersOverview/OrdersOverview.js": 358,
	"./views/PositionsOverview/PositionsOverview": 359,
	"./views/PositionsOverview/PositionsOverview.css": 848,
	"./views/PositionsOverview/PositionsOverview.js": 359,
	"./views/SellEquity/SellEquity": 360,
	"./views/SellEquity/SellEquity.css": 1205,
	"./views/SellEquity/SellEquity.js": 360,
	"./views/Stake/Stake": 849,
	"./views/Stake/Stake.css": 1206,
	"./views/Stake/Stake.js": 849,
	"./views/Stake/StakeV2": 361,
	"./views/Stake/StakeV2.css": 850,
	"./views/Stake/StakeV2.js": 361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 903;